import script from "./LabEnvironment.vue?vue&type=script&setup=true&lang=ts"
export * from "./LabEnvironment.vue?vue&type=script&setup=true&lang=ts"

import "./LabEnvironment.vue?vue&type=style&index=0&id=adcae974&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src669166032/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-adcae974"]])

export default __exports__